import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import moment from 'moment';
import 'moment-timezone'
import _ from 'underscore';

import Miza from './Miza';
import SistemUnique from './SistemUnique';
import SistemMulty from './SistemMulty';
import NrFavorite from './NrFavorite';
// import Procent from '../containers/Procent'

import { acBiletTab } from '../actions/acBiletTab'
import { acBilet } from '../actions/acBilet';
import { acCalculBilet } from '../actions/acCalculBilet';
import { acSendTicket } from '../actions/acSendTicket';
import { acPopVizibil } from '../actions/acPopVizibil'
import { acDeleteTicketPariat } from '../actions/acDeleteTicketPariat'
import { acRundaSelectata } from '../actions/acRundaSelectata'
import { acAxiosRequest } from '../actions/acAxiosRequest'
import Future from './Future';

class BiletItem extends React.Component {

    componentDidMount() {

        if (this.props.bilete !== null) {
            var calculBilet = {
                bilet: this.props.bilete[0],
                defaultVal: this.props.defaultVal
            }
            this.props.acCalculBilet(calculBilet)

            if (this.props.bilete.length > 0 && this.props.appProps.colMid !== "Mid1ConNr") {
                var findBiletThis = _.findWhere(this.props.bilete, { position: this.props.biletTab });

                if (this.props.nrFavorite === null) {
                    var nrFav = {
                        ruta: this.props.appProps.ruta,
                        reducer: 'NR_FAVORITE',
                        request: 'get_user_favorites',
                        value: 'lottery_name=' + findBiletThis.numeLot.replace(/ /g, "_"),
                        error: '5000',
                        newParam: this.props.sessionParam
                    }
                    this.props.acAxiosRequest(nrFav);
                }
            }
        }

    }
    componentDidUpdate(prevProps, prevState) {
        if (this.props.deleteTicketPariat === true) {
            this.timerDeleteTicketPariat();
        }

        if (this.props.bilete && this.props.bilete.length > 0) {
            if ((prevProps.serverTime) && (this.props.serverTime)) {
                if (moment(prevProps.serverTime.date_server_time) <= moment(this.props.serverTime.date_server_time)) {
                    this.checkRoundExpired()
                }
            }
            var findBilet1 = _.findWhere(this.props.bilete, { position: this.props.biletTab });
            var findBilet2 = _.findWhere(prevProps.bilete, { position: this.props.biletTab });
            if (findBilet1 && (_.isEqual(findBilet1, findBilet2) === false)) {
                var calculBilet = {
                    bilet: findBilet1,
                    defaultVal: this.props.defaultVal
                }
                this.props.acCalculBilet(calculBilet)

                if (findBilet1.numereArr.length === 0) {
                    this.deleteBilet(findBilet1)
                }
            }
        }
    }
    checkRoundExpired() {
        for (let i = 0; i < this.props.bilete.length; i++) {
            if (this.props.bilete[i].valid === true) {
                if (moment(this.props.bilete[i].timeStart) <= moment(this.props.serverTime.date_server_time)) {
                    var values = {
                        position: this.props.bilete[i].position,
                        mesaj: this.props.multiLang.expTicket.txt,
                        valid: false
                    }
                    this.props.acBilet(['validTicket', values])
                }
            }
        }
    }

    changeBiletTab(val) {
        var findBilet = _.findWhere(this.props.bilete, { position: val });

        // console.log('090', findBilet, this.props.activeLot);
        if (findBilet && findBilet.numeLot === this.props.activeLot.name_lot) {
            if (findBilet.valid === true) {
                var rundaSelect = {
                    gameType: findBilet.gameType,
                    id: findBilet.idRunda,
                    round_unique: findBilet.roundUnique,
                    selectedLot: findBilet.numeLot,
                    timeStart: findBilet.timeStart
                }
                this.props.acRundaSelectata(rundaSelect)
            }
        }
        this.props.acBiletTab(val);

    }
    htmlNumere(val) {
        var arr = []
        for (var i = 0; i < val.numereArr.length; i++) {
            arr.push(<div key={i} className="bila-active" onClick={this.removeNumbers.bind(this, [val, val.numereArr[i]])}><span>{val.numereArr[i]}</span></div>);
        }
        return arr;
    }
    removeNumbers(val) {
        var values = {
            position: val[0].position,
            number: val[1],
            biletNumbers: val[0].numereArr,
            odds: this.props.activeLot.odds
        }
        this.props.acBilet(['biletNumere', values])
    }
    deleteBilet(val) {
        var values = {
            position: val.position,
        }
        this.props.acBilet(['biletDelete', values])
    }
    resetMessage() {
        this.props.acBilet(['resetMessage'])
    }
    sendTicket(val, type) {
        this.resetMessage()
        
        var rundeArr = []
        for (let i = 0; i < this.props.runde.length; i++) {
            rundeArr.push(this.props.runde[i].timeStart)
        }
        var rai = _.indexOf(rundeArr, val.timeStart);
        var futureArr = rundeArr.slice(rai, rai + parseInt(val.future)+ 1)
        if (val.future === 0) {
            val = {
                ...val,
                ruta: this.props.appProps.ruta,
                newParam: this.props.sessionParam
            }
            this.props.acSendTicket(val)
        } else {
            if(type === "multi" && val?.futureArr.length > 0) {
                futureArr = val.futureArr
            }
            for (var i = 0; i < futureArr.length; i++) {
                val = {
                    ...val,
                    timeStart: futureArr[i],
                    ruta: this.props.appProps.ruta,
                    newParam: this.props.sessionParam
                }
                this.props.acSendTicket(val)
            }
        }
    }
    sendTicketTot() {
        for (var i = 0; i < this.props.bilete.length; i++) {
            this.sendTicket(this.props.bilete[i], 'multi')
        }
    }
    timerDeleteTicketPariat() {
        if (this.props.bilete && this.props.bilete.length > 0) {
            if (this.timeout) {
                clearTimeout(this.timeout)
            }
            this.timeout = setTimeout(() => {
                for (let i = 0; i < this.props.bilete.length; i++) {
                    if ((this.props.bilete[i].pariat === true) && (this.props.bilete[i].valid === true)) {
                        this.deleteBilet(this.props.bilete[i])
                    }
                }
            }, 3000);
        } else {
            this.props.acDeleteTicketPariat(false)
        }
    }
    mesajClass(val) {
        if (val.pariat === true) {
            if (val.valid === true) { return 'succes' }
            if (val.valid === false) { return 'error' }
        } else if ((val.pariat === false) && (val.valid === false) && (val.mesaj !== "")) {
            return 'error';
        } else if (val.mesaj === "Bilet expirat") {
            return 'error';
        } else {
            return '';
        }
    }
    disabledPariaza(val) {
        if (this.props.loading === 'sendTicket' || val.valid === false || val.miza === 0) {
            return true
        } else {
            return false
        }
    }
    systemType(val) {
        if (this.props.appProps.systemType === 'unique') {
            return <SistemUnique biletVal={val} />
        }
        else if (this.props.appProps.systemType === 'multy') {
            return <SistemMulty biletVal={val} />
        }
    }
    castigPosibil(val) {
        var bool = false;
        for (var i = 0; i < val.sum.length; i++) {
            if (val.sum[i] !== 0) {
                bool = true;
            }
        }
        if (bool === true) {
            return (<th colSpan="2">{this.props.multiLang.possWin2.txt}</th>)
        }
    }
    _trValues(val) {
        var minBile_GameType = Math.min(val.gameType.split('/')[0], val.sum.length);
        var slice = val.sum.slice(0, minBile_GameType)
        return (
            slice.map((val2, i) => {
                if (val2 !== 0) {
                    return (
                        <tr key={i}>
                            <td>
                                {i + 1}{(i + 1 !== 1) ? this.props.multiLang.nb2.txt : this.props.multiLang.nb.txt}
                            </td>
                            <td>
                                {val2}
                            </td>
                        </tr>
                    )
                } return true
            })
        )
    }
    winArrayDetailed(val) {
        return (
            <div id="win-array-cont">
                <img className="img-win-array-detailed" id="info-img" src="img/icon/info.svg" alt="" />
                <div className="win-array-detailed">
                    <table>
                        <thead>
                            <tr>
                                {this.castigPosibil(val)}
                            </tr>
                        </thead>
                        <tbody>
                            {this._trValues(val)}
                        </tbody>
                    </table>
                </div>
            </div>
        )
    }
    nrPariuri() {
        var nr = 0
        for (let i = 0; i < this.props.bilete.length; i++) {
            nr = nr + 1 + 1 * this.props.bilete[i].future

        }
        return nr
    }
    nrFav() {
        if (this.props.nrFavorite !== null && this.props.appProps.colMid !== "Mid1ConNr") {
            // console.log('intra');
            return (
                <NrFavorite />
            )
        }
        // else {
        //     console.log('NU intra');
        //     return (
        //         <NrFavorite />
        //     )
        // }
    }
    biletTab() {
        var bilet = ''
        var system
        if (this.props.conSizeChange.appW <= 1588) {
            system = this.props.multiLang.system.txt + ' ( ' + this.props.multiLang.pariuri.txt + ' )'
        } else {
            system = this.props.multiLang.system.txt
        }
        var biletTab = this.props.biletTab;
        if (this.props.bilete && this.props.bilete.length > 0) {
            var result = this.props.bilete.filter(function (obj) {
                return obj.position === biletTab;
            });
        } else {
            result = undefined
        }
        if (result && result[0] !== undefined) {
            var time = result[0].timeStart.slice(5, result[0].timeStart.length - 3)
            // .replace(/ /, ' | ')
            var date = time.split(" ")[0]
            var hour = time.split(" ")[1]
        } else {
            time = ''
        }
        if (result && result.length > 0) {
            var miza = 0
            var win = 0
            this.props.bilete.map((val, j) => {
                miza = miza + (val.miza * (1 + val.future))
                win = win + (val.castigEv * (1 + val.future))
                return (miza, win)
            })
            if (this.props.activeLot.future === true || result[0].future > 0) {
                var futureDisplay = <Future />
            } else {
                futureDisplay = ''
            }
            bilet =
                <div className="bilet">
                    {futureDisplay}
                    <div className="bilet-header">
                        <div>{result[0].numeLot} {result[0].gameType}</div>
                        <div><span>{date}</span> | <span>{hour}</span></div>
                        <div
                            className="closeTicket"
                            onClick={this.deleteBilet.bind(this, result[0])}>
                            <img src="img/icon/biletX.png" alt="" />
                        </div>
                    </div>
                    <div className="con-bilet-bile">
                        <div className="bilet-bile">{this.htmlNumere(result[0])}</div>
                    </div>
                    {this.nrFav()}
                    <div className={"mesaj-bilet " + this.mesajClass(result[0])}>{result[0].mesaj}</div>
                    <div className="bilet-sisteme">
                        <div className="sisteme-title module-header">
                            {system}</div>
                        {this.systemType(result[0])}
                    </div>
                    <div className="bilet-footer">
                        <Miza biletVal={result[0]} />
                    </div>
                    <div className="all-tickets-info">
                        <div className="total-pariuri">
                            <span>{this.props.multiLang.totalBets.txt}</span>
                            <span>{this.nrPariuri()}</span>
                        </div>
                        <div className="total-miza">
                            <span>{this.props.multiLang.totalStake.txt}</span>
                            <span>{Math.round(miza * 100.0) / 100.0}</span>
                        </div>
                        <div className="total-win">
                            <span>{this.props.multiLang.win2.txt}</span>
                            <span>{win.toFixed(2) + ' ' + this.props.defaultVal.currency}</span>
                        </div>
                    </div>
                    <div className="bilet-butoane">
                        <button
                            className="but-pariaza"
                            onClick={this.sendTicket.bind(this, result[0])}
                            disabled={this.disabledPariaza(result[0])}
                        >{this.props.multiLang.pariazaBut.txt}
                        </button>
                        <button
                            className="but-pariaza-tot"
                            onClick={this.sendTicketTot.bind(this)}
                            disabled={this.disabledPariaza(result[0])}
                        >{this.props.multiLang.pariazaButTot.txt}
                        </button>
                    </div>
                    <div className="delete">
                        <div onClick={this.deleteBilet.bind(this, result[0])}>
                            {/* <img src="img/icon/delete.svg" alt="" /> */}
                            {this.props.multiLang.deleteSelec.txt}</div>
                        <div className="zigzag"></div>
                    </div>
                </div>;
        } else {
            bilet = <div className="zero-bilete empty-ticket">{this.props.multiLang.emptyTicket.txt}</div>;
        }
        return bilet
    }
    selectedTab(val) {
        if (val === this.props.biletTab) {
            return 'active '
        } else {
            return ''
        }
    }

    alert(val) {
        if (this.props.bilete && this.props.bilete.length > 0) {
            return (
                this.props.bilete.map((val2, i) => {
                    if ((val2.valid === false) && (val2.position === val)) {
                        return (
                            'alert '
                        )
                    } else {
                        return ''
                    }
                })
            )
        } else {
            return ''
        }

    }
    nepariat(poz) {
        var pozitii = []
        if (this.props.bilete !== null) {
            this.props.bilete.map((val, i) => {
                if (val.valid === true && val.pariat === false && val.position !== poz) {
                    pozitii.push(val.position)
                }
                return true
            })
            return pozitii
        }
        // this.setState({
        //     nepariate: pozitii
        // })
    }
    tabButtons() {
        var arr = [];
        var pozitiiBilNepariate = [];

        if (this.props.bilete !== null) {
            this.props.bilete.map((val, i) => {
                if (val.valid === true && val.pariat === false && val.position !== this.props.biletTab) {
                    pozitiiBilNepariate.push(val.position)
                } return true
            })
        }

        for (var i = 1; i <= this.props.appProps.nrTabs; i++) {
            arr.push(
                <div
                    key={i}
                    onClick={this.changeBiletTab.bind(this, i)}
                    className={this.selectedTab(i) + _.compact(this.alert(i)) + 'bilete-btn ' + _.contains(pozitiiBilNepariate, i)}
                >
                    {i}
                </div>
            )
        }
        return (
            <div className='con-bilet-tab'>
                {arr}
            </div>
        )
    }
    render() {
        // console.log('bilet', this.props.bilete, 'activeLot', this.props.activeLot);
        return (
            <div className='con-bilet'>
                {this.tabButtons()}
                {this.biletTab()}
            </div>
        )
    }
}
function mapStateToProps(state) {
    return {
        bilete: state.bilete,
        biletTab: state.biletTab,
        defaultVal: state.defaultVal,
        appProps: state.appProps,
        loading: state.loading,
        multiLang: state.multiLang,
        activeLot: state.activeLot,
        serverTime: state.serverTime,
        deleteTicketPariat: state.deleteTicketPariat,
        runde: state.runde,
        nrFavorite: state.nrFavorite,
        conSizeChange: state.conSizeChange,
        sessionParam: state.sessionParam
    }
}
function matchDispatchToProps(dispatch) {
    return bindActionCreators({
        acBiletTab: acBiletTab,
        acBilet: acBilet,
        acCalculBilet: acCalculBilet,
        acSendTicket: acSendTicket,
        acPopVizibil: acPopVizibil,
        acDeleteTicketPariat: acDeleteTicketPariat,
        acRundaSelectata: acRundaSelectata,
        acAxiosRequest: acAxiosRequest
    }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(BiletItem);
